import { Box, Typography } from '@mui/material';

const CpdLabeledValue = ({
  label,
  value,
  labelVariant = 'caption',
  valueVariant = 'body1',
  labelColor = 'textSecondary',
  valueSx = {},
  sx = {},
}) => {
  return (
    <Box sx={sx}>
      <Typography variant={labelVariant} color={labelColor}>
        {label}
      </Typography>
      <Typography variant={valueVariant} sx={valueSx}>
        {value}
      </Typography>
    </Box>
  );
};

export default CpdLabeledValue;
